@if (authService.configuration) {
  <section
    [ngStyle]="{ 'background-image': 'url(' + configuration.splash + ')' }"
    class="authentication__splash"
  >
    <div class="authentication__mobile__cover">
      <div class="container">
        <div class="u-flex u-justifyEnd">
          <div class="authentication__form">
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="authentication__content">
    <div class="container">
      <header class="authentication__header">
        @if (configuration?.content?.icon) {
          <icon
            [config]="{ fill: 'primary', set: 'product', size: 'large' }"
            [name]="configuration.content.icon"
          ></icon>
        }
        @if (configuration?.content?.title) {
          <h4 class="t-bold">
            {{ configuration.content.title }}
          </h4>
        }
        @if (configuration?.content?.subtitle) {
          <p>
            {{ configuration.content.subtitle }}
          </p>
        }
      </header>
      <section class="authentication__columns">
        @for (column of configuration.content.columns; track column) {
          @if (checkIfConfigContainsAnyValues(column)) {
            <div class="authentication__column">
              @if (column?.label) {
                <h4 class="t-bold">{{ column.label }}</h4>
              }
              @if (column.description) {
                <p>{{ column.description }}</p>
              }
              @if (column.checklist) {
                <ul class="authentication__list">
                  @for (item of column.checklist; track item) {
                    <li class="authentication__item">
                      <icon name="check"></icon>
                      <p>{{ item }}</p>
                    </li>
                  }
                </ul>
              }
              @if (column.links) {
                <ul class="authentication__list">
                  @for (link of column.links; track link) {
                    <li class="authentication__item">
                      <p class="t-link">{{ link.label }}</p>
                      <icon [config]="{ type: 'link' }" name="chevron_right">
                      </icon>
                    </li>
                  }
                </ul>
              }
              @if (checkIfConfigContainsAnyValues(column.button)) {
                <zip-button [config]="column.button"> </zip-button>
              }
            </div>
          }
        }
      </section>
    </div>
  </section>
  @if (configuration.footer) {
    <portal-footer [config]="configuration.footer"></portal-footer>
  }
}
